module.exports = __webpack_public_path__ + "img/I-09524_02-e.a64aa0f8.jpg";